import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.report');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-report',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.report/view.scss */
.report-page {
  min-height: 100vh;
  background: #f5f7fb;
  color: #111827;
  padding: 32px;
}

.report-head,
.report-band {
  max-width: 1480px;
  margin: 0 auto 18px;
}

.report-head {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(280px, 420px);
  gap: 24px;
  align-items: end;
}

.title-block .eyebrow {
  margin: 0 0 10px;
  color: #0f766e;
  font-size: 13px;
  font-weight: 850;
  letter-spacing: 0;
  text-transform: uppercase;
}
.title-block h1 {
  margin: 0;
  color: #0f172a;
  font-size: 38px;
  font-weight: 850;
  line-height: 1.14;
  letter-spacing: 0;
}
.title-block .summary {
  max-width: 900px;
  margin: 14px 0 0;
  color: #475569;
  font-size: 16px;
  line-height: 1.6;
}

.top-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 18px;
}

.nav-link {
  display: inline-flex;
  align-items: center;
  min-height: 36px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #ffffff;
  color: #0f172a;
  padding: 0 12px;
  font-size: 13px;
  font-weight: 850;
  text-decoration: none;
}
.nav-link:hover {
  border-color: #0f766e;
  background: #f0fdfa;
  color: #0f766e;
}

.report-meta {
  display: grid;
  gap: 8px;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);
  padding: 16px;
}
.report-meta span {
  color: #64748b;
  font-size: 12px;
  font-weight: 850;
  text-transform: uppercase;
}
.report-meta strong {
  color: #0f172a;
  font-size: 15px;
  font-weight: 900;
  overflow-wrap: anywhere;
}
.report-meta small {
  color: #475569;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
}

.report-band {
  display: grid;
  grid-template-columns: minmax(300px, 0.78fr) minmax(0, 1.22fr);
  gap: 18px;
  align-items: stretch;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
  padding: 18px;
}

.section-copy {
  display: grid;
  align-content: start;
  gap: 14px;
}
.section-copy .section-kicker {
  margin: 0;
  color: #0f766e;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0;
  text-transform: uppercase;
}
.section-copy h2 {
  margin: 0;
  color: #0f172a;
  font-size: 24px;
  font-weight: 900;
  letter-spacing: 0;
}
.section-copy p {
  margin: 0;
  color: #475569;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.65;
}

.point-list {
  display: grid;
  gap: 10px;
}
.point-list article {
  display: grid;
  gap: 5px;
  border-left: 4px solid #0f766e;
  background: #f8fafc;
  padding: 10px 12px;
}
.point-list strong {
  color: #0f172a;
  font-size: 13px;
  font-weight: 900;
}
.point-list span {
  color: #475569;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.45;
}

.visual-panel {
  min-height: 320px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  overflow: hidden;
}

.report-svg {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 320px;
}
.report-svg text {
  fill: #0f172a;
  font-size: 18px;
  font-weight: 850;
}
.report-svg .small {
  fill: #475569;
  font-size: 13px;
  font-weight: 700;
}
.report-svg .caption {
  fill: #64748b;
  font-size: 14px;
  font-weight: 800;
}
.report-svg .score {
  fill: #0f172a;
  font-size: 34px;
  font-weight: 950;
}

.result-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.result-grid article {
  display: grid;
  gap: 6px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 12px;
}
.result-grid span {
  color: #64748b;
  font-size: 12px;
  font-weight: 850;
}
.result-grid strong {
  color: #0f172a;
  font-size: 23px;
  font-weight: 950;
  line-height: 1;
}
.result-grid small {
  color: #475569;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
}

.claim-box {
  display: grid;
  gap: 6px;
  border-left: 4px solid #0f766e;
  background: #ecfdf5;
  padding: 12px 14px;
}
.claim-box strong {
  color: #0f172a;
  font-size: 13px;
  font-weight: 900;
}
.claim-box span {
  color: #134e4a;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.55;
}

.term-list {
  display: grid;
  gap: 10px;
}
.term-list article {
  display: grid;
  grid-template-columns: minmax(82px, 0.28fr) minmax(0, 1fr);
  gap: 10px;
  align-items: start;
  border-top: 1px solid #e2e8f0;
  padding-top: 10px;
}
.term-list strong {
  color: #0f766e;
  font-size: 13px;
  font-weight: 900;
}
.term-list span {
  color: #475569;
  font-size: 13px;
  font-weight: 750;
  line-height: 1.5;
}

.paper-table {
  width: 100%;
  border-collapse: collapse;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  font-size: 13px;
}
.paper-table th,
.paper-table td {
  border-bottom: 1px solid #e2e8f0;
  padding: 10px 11px;
  text-align: left;
  vertical-align: top;
}
.paper-table th {
  background: #f8fafc;
  color: #0f172a;
  font-weight: 900;
}
.paper-table td {
  color: #475569;
  font-weight: 750;
}
.paper-table tr:last-child td {
  border-bottom: 0;
}

.grouping-visual {
  display: grid;
  align-content: center;
  gap: 18px;
  padding: 20px;
}

.grouping-lanes {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 34px minmax(0, 1fr) 34px minmax(0, 1fr);
  gap: 12px;
  align-items: center;
}
.grouping-lanes article {
  display: grid;
  gap: 8px;
  min-height: 132px;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  background: #ffffff;
  padding: 14px;
}
.grouping-lanes i {
  color: #0f766e;
  font-size: 20px;
  text-align: center;
}
.grouping-lanes span {
  color: #64748b;
  font-size: 12px;
  font-weight: 900;
  text-transform: uppercase;
}
.grouping-lanes strong {
  color: #0f172a;
  font-size: 17px;
  font-weight: 950;
  line-height: 1.2;
}
.grouping-lanes small {
  color: #475569;
  font-size: 12px;
  font-weight: 750;
  line-height: 1.45;
}

.grouping-note {
  display: grid;
  gap: 8px;
  border-left: 4px solid #0f766e;
  background: #ecfdf5;
  padding: 12px 14px;
}
.grouping-note strong {
  color: #0f172a;
  font-size: 13px;
  font-weight: 900;
}
.grouping-note span {
  color: #134e4a;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.55;
  overflow-wrap: anywhere;
}

.purpose-band .visual-panel {
  background: #f8fafc;
}

.architecture-band .visual-panel {
  background: #f7fee7;
}

.experiment-band .visual-panel {
  background: #fff7ed;
}

.conclusion-band .visual-panel {
  background: #f8fafc;
}

@media (max-width: 1120px) {
  .report-head,
  .report-band {
    grid-template-columns: 1fr;
  }
  .report-head {
    align-items: start;
  }
}
@media (max-width: 720px) {
  .report-page {
    padding: 20px;
  }
  .title-block h1 {
    font-size: 30px;
  }
  .report-band {
    padding: 14px;
  }
  .result-grid {
    grid-template-columns: 1fr;
  }
  .grouping-lanes {
    grid-template-columns: 1fr;
  }
  .grouping-lanes i {
    transform: rotate(90deg);
  }
  .term-list article {
    grid-template-columns: 1fr;
  }
  .visual-panel,
  .report-svg {
    min-height: 260px;
  }
}`],
})
export class PageReportComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init(this);
    }
}

export default PageReportComponent;